import { createContext } from 'react'
import type { ThemeResult } from '../data/ThemeFragment'

export const PageThemeContext = createContext<ThemeResult | undefined>(undefined)
